const modalBase = 1040;
const sidebar = 6;
const zIndices = {
  sidebar,
  sidebarContentColumn: sidebar + 1,
  sidebarOverlay: sidebar - 1,
  modalOverlay: modalBase,
  modalBody: modalBase + 10,
  confirmModalOverlay: modalBase + 11,
  confirmModalBody: modalBase + 12,
  notifications: modalBase + 13,
  dropdownMenu: modalBase + 13
};
export default zIndices;
